export default "__VITE_ASSET__d2a62f85__"